<template>
  <svg class="w-full h-full" viewBox="0 0 110 160" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_1577_4692)">
  <path d="M0 39.5V78.5H41V0H82.5V39.5H0Z" stroke="#8AB9B7" stroke-opacity="0.25"/>
  <path d="M53 159.829L53 138.631L114.751 72.9631L53 72.9631L53 49L141.71 49L153 60.9816V159.829H129.267V91.1659L67.2857 159.829H53Z" stroke="#8AB9B7" stroke-opacity="0.25"/>
  </g>
  <defs>
  <clipPath id="clip0_1577_4692">
  <rect width="110" height="160" fill="white"/>
  </clipPath>
  </defs>
  </svg>
</template>
